import { PATH_DASHBOARD } from '../../routes/paths';
import Icon from 'components/icons/Icon';
import { AccessRule, legacyRoleRules, rules } from 'access';
import { ReactNode } from 'react';
import { ITranslator } from 'translation/generated/translationInterface';

const ICONS = {
  ordersIcon: <Icon type="orderandusage" />,
  organization: <Icon type="account" />,
  dashboard: <Icon type="dashboard" />,
  campaign: <Icon type="campaigns" />,
  employee: <Icon type="employees" />,
  company: <Icon type="companies" />,
  respondents: <Icon type="respondents" />,
  pGapIcon: <Icon type="pgap" />,
  ivrIcon: <Icon type="ivr" />,
  reportIcon: <Icon type="reports" />,
  reviewIcon: <Icon type="reviews" />,
  productOrdersIcon: <Icon type="integrationstore" />,
  productConfigurationsIcon: <Icon type="productconfigurations" />,
  integrationsReadMoreIcon: <Icon type="link" />
};

export type SidebarItem = {
  title: string;
  path: string;
  icon?: ReactNode;
  rule?: AccessRule;
};

export const getSidebarConfig = (
  conditionallyEnabledIntegrations: SidebarItem[],
  conditionallyEnabledGeneralItems: SidebarItem[],
  translator: ITranslator
): {
  subheader: string;
  items: SidebarItem[];
}[] => [
  {
    subheader: translator.general(),
    items: [
      {
        title: translator.dashboard(),
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard
      },
      {
        title: translator.campaigns(),
        path: PATH_DASHBOARD.campaigns.root,
        icon: ICONS.campaign
      },
      { title: translator.employees(), path: PATH_DASHBOARD.employees.root, icon: ICONS.employee },
      {
        title: translator.respondents(),
        path: PATH_DASHBOARD.respondents.root,
        icon: ICONS.respondents
      },
      { title: translator.companies(), path: PATH_DASHBOARD.companies.root, icon: ICONS.company },
      { title: translator.reports(), path: PATH_DASHBOARD.reports.root, icon: ICONS.reportIcon },
      {
        title: translator.pGap(),
        path: PATH_DASHBOARD.pGap.root,
        icon: ICONS.pGapIcon,
        rule: rules.module.pgap
      },
      {
        title: translator.reviews(),
        path: PATH_DASHBOARD.reviews.root,
        icon: ICONS.reviewIcon,
        rule: rules.module.reviews
      },
      ...conditionallyEnabledGeneralItems
    ]
  },
  {
    subheader: translator.management(),
    items: [
      {
        title: translator.account(),
        path: PATH_DASHBOARD.organization.root,
        icon: ICONS.organization
      },
      {
        title: translator.orders(),
        path: PATH_DASHBOARD.orders.root,
        icon: ICONS.ordersIcon,
        rule: rules.order.read
      },
      {
        title: translator.productOrders(),
        path: PATH_DASHBOARD.productOrders.root,
        icon: ICONS.productOrdersIcon,
        rule: rules.order.read
      },
      {
        title: translator.productConfigurations(),
        path: PATH_DASHBOARD.productConfigurations.root,
        icon: ICONS.productConfigurationsIcon,
        rule: legacyRoleRules.adminOnly
      }
    ]
  },
  {
    subheader: translator.integrations(),
    items: [
      {
        title: translator.discover(),
        path: PATH_DASHBOARD.discoverIntegrations.root,
        icon: ICONS.integrationsReadMoreIcon
      },
      {
        title: translator.ivr(),
        path: PATH_DASHBOARD.ivr.root,
        icon: ICONS.ivrIcon,
        rule: rules.module.ivr
      },
      {
        title: 'etrack1',
        path: PATH_DASHBOARD.eTrack1.root,
        rule: rules.module.etrack1
      },
      ...conditionallyEnabledIntegrations
    ]
  }
];
